import { CSSProperties } from "react";
import { contract } from "@react95/core";

export function HorizDivider() {
  return (
    <div
      style={{
        borderBottomStyle: "solid",
        borderWidth: "1px",
        borderBottomColor: contract.colors.borderDark,
        boxShadow: `0 1px 0 0 ${contract.colors.borderLighter}`,
      }}
    />
  );
}

export  function VertDivider() {
  return (
    <div
      style={{
        width: "1px",
        alignSelf: "stretch",
        borderRightStyle: "solid",
        borderWidth: "1px",
        borderRightColor: contract.colors.borderDark,
        boxShadow: `1px 0 0 0 ${contract.colors.borderLighter}`,
      }}
    />
  );
}

export function DoubleVertDivider(props: { style?: CSSProperties }) {
  return (
    <div style={{ display: "flex", gap: "1px", alignSelf: "stretch", ...props.style }}>
      <VertDivider />
      <VertDivider />
    </div>
  );
}
